import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SETTINGS} from '../config/common.settings';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ItineraryService {
  pagedItineraries: any = [];
  onPagedItinerariesChange: Subject<any> = new BehaviorSubject({});
  itinerary: any;
  onItineraryChange: Subject<any> = new BehaviorSubject({});
  getOverviewImages: any;

  constructor(private http: HttpClient) {
  }

  getPagedItineraries(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            this.pagedItineraries = response[0];
            this.onPagedItinerariesChange.next(this.pagedItineraries);
            resolve(this.pagedItineraries);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  createItinerary(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response;
            this.onItineraryChange.next(this.itinerary);
            this.recentlyItineraryCurrencyAndLanguageSet(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  createItineraryFromTemplate(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/create-from-template`, payload)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response;
            this.onItineraryChange.next(this.itinerary);
            this.recentlyItineraryCurrencyAndLanguageSet(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getItineraryById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/get-one`, payload)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response[0];
            this.onItineraryChange.next(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getClientPreviewItineraryById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${SETTINGS.BASE_API}/itineraries/get-one/client-preview`,
          payload
        )
        .subscribe({
          next: (response: any) => {
            this.itinerary = response[0];
            this.onItineraryChange.next(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateItinerary(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/itineraries/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response;
            this.onItineraryChange.next(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateB2BItinerary(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/itineraries/update/b2b`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  deleteItinerary(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/itineraries/delete/${id}`)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response;
            this.onItineraryChange.next(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  removeItineraryLockState(id: string, sessionId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/itineraries/delete/lock/${id}`, { body: { sessionId } })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getItineraryByIdLockState(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/get-one/lock`, payload)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response[0];
            this.onItineraryChange.next(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  extendLockState(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/extend/lock`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateItineraryLockState(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/itineraries/update/lock`, payload)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response;
            this.onItineraryChange.next(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            // TODO implement better in the component instead of the service
            if(error?.error?.code === 'ITINERARY_STATUS_ERROR' ){
              window.location.reload();
            }
            reject(error);
          },
        });
    });
  }

  emailSendToCustomerItinerary(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/email`, payload)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response;
            this.onItineraryChange.next(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  emailSendToAdminsItinerary(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/email/link-previewed`, payload)
        .subscribe({
          next: (response: any) => {
            this.itinerary = response;
            this.onItineraryChange.next(this.itinerary);
            resolve(this.itinerary);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getOverviewImagesItinerary(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/itineraries/get-overview-images/${id}`)
        .subscribe({
          next: (response: any) => {
            this.getOverviewImages = response[0]?.all_images || [];
            resolve(this.getOverviewImages);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  private recentlyItineraryCurrencyAndLanguageSet(
    data: any
  ): void {
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.CURRENCY,
      data.tour.currency
    );
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.LANGUAGE,
      data.tour.language
    );
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.AGENT,
      data?.tour?.agent
    );
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.TYPE,
      data?.tour?.type
    );
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.CUSTOMER,
      data?.tour?.customer
    );
  }

  recentlyItineraryCurrencyAndLanguageGet(): any {
    const currency = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.CURRENCY
    );
    const language = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.LANGUAGE
    );
    const agent = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.AGENT
    );
    const type = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.TYPE
    );
    const customer = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.CUSTOMER,
    );
    return {currency, language, agent, type, customer};
  }
  getPagedStatusLog(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itineraries/get-status-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response[0]);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
